import { useLoginForm } from './Form.h'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import { FormProvider } from 'react-hook-form'
import { Link as RRDLink } from 'react-router-dom'
import FormTextField from '@shared/components/FormTextField'

export default function Login() {
    const {
        form,
        mutate
    } = useLoginForm()

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(mutate)}>
                <Stack>
                    <Typography variant='h5'>تسجيل الدخول</Typography>
                    <br />
                    <FormTextField
                        name='username'
                        label='الرقم الوظيفي'
                    />
                    <FormTextField
                        name='password'
                        label='كلمة المرور'
                        type='password'
                    />
                    <Link
                        component={RRDLink}
                        to='/auth/recovery-password'
                        underline='none'
                    >نسيت كلمة المرور؟</Link>
                    <br />
                    <Box sx={{
                        display:'flex',
                        flexDirection:'row-reverse',
                        justifyContent:'space-between'
                    }}>
                        <Button
                            type='submit'
                            variant='contained'
                            sx={{boxShadow: 0}}
                        >الدخول</Button>
                    </Box>
                </Stack>
            </form>
        </FormProvider>
    )
}
